import angular from 'angular';


(function () {
    'use strict';
    angular.module('app.core').factory('GlobalSettingDA', GlobalSettingDA);

    GlobalSettingDA.$inject = ['CONF', 'Restangular'];

    /* @ngInject */
    function GlobalSettingDA(CONF,Restangular) {
        var baseUrl = CONF.apiBaseUrl + '/v1/global-setting';

        var exports = {
            saveGlobalSetting: saveGlobalSetting,
            getAllGlobalSetting: getAllGlobalSetting
        };

        return exports;

        function saveGlobalSetting(globalSetting) {
            return Restangular.all(baseUrl).post(globalSetting);
        }

        function getAllGlobalSetting() {
            return Restangular.one(baseUrl)
                .get();
        }
    }
})();
